import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectGroup } from '../../../../redux/groups/selectors';
import { GROUPS_ACTIONS } from '../../../../redux/groups/actions';
import AdminSubHeader from '../../../layouts/partials/AdminSubheader';
import GroupForm from '../../../forms/GroupForm';

class _GroupsEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id
    };

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadGroups();
  }

  _handleSubmit(values) {
    const data = {
      name: values.name,
      permissionIds: values.permissions
    };
    this.props.updateGroup(this.state.id, data);
  }

  static propTypes = {
    match: PropTypes.object,
    loadGroups: PropTypes.func,
    group: PropTypes.object,
    updateGroup: PropTypes.func,
    'match.params': PropTypes.object,
    'match.params.id': PropTypes.number
  };

  render() {
    const { group } = this.props;

    const breadcrumbs = [
      {
        title: 'Groups',
        to: '/admin/groups'
      }
    ];

    return [
      <AdminSubHeader
        title={'Edit Group | ' + (group ? group.name : '')}
        key="subheader"
        breadcrumbs={breadcrumbs}
      />,
      <div className="m-content" key="content">
        {group && <GroupForm onSubmit={this._handleSubmit} group={group} />}
      </div>
    ];
  }
}

const mapStateToProps = function(state, props) {
  return {
    group: selectGroup(parseInt(props.match.params.id, 10))(state)
  };
};

const mapDispatchToProps = dispatch => ({
  loadGroups: () => dispatch(GROUPS_ACTIONS.loadAllRequest()),
  updateGroup: (id, values) =>
    dispatch(GROUPS_ACTIONS.updateRequest(id, values))
});

const GroupsEdit = connect(mapStateToProps, mapDispatchToProps)(_GroupsEdit);

export default GroupsEdit;
